<template>

  <form @submit.prevent="submit">
    <div class="row">
      <div class="input-field col s12 l4">
        <input v-model="domain" id="domain" placeholder="peertube.domain" type="text" class="validate">
        <label class="active" for="domain">PeerTube domain</label>
      </div>
      <div class="input-field col s12 l4">
        <input v-model="username" id="username" type="text" class="validate">
        <label for="username">Username</label>
      </div>
      <div class="input-field col s12 l4">
        <input v-model="password" id="password" type="password" class="validate">
        <label for="password">Password</label>
      </div>
    </div>
    <p>You're password is only used to obtain the first authentication token and isn't stored.</p>
    <button type="submit" class="waves-effect waves-light btn">Authenticate</button>
  </form>
</template>

<script>
import axios from 'axios'

import {createApp, getAxios, connect} from '@/sources/peertube'
import {getBaseUrl} from '@/utils'

export default {
  props: ["source"],
  data () {
    return {
      domain: '',
      username: '',
      password: '',
    }
  },
  mounted () {
    M.updateTextFields();
  },
  methods: {
    async submit () {
      let instanceUrl = `https://${this.domain}/`
      // create an application
      let ax = axios.create({
        baseURL: instanceUrl,
        timeout: 3000,
      })
      let response = await createApp(ax)
      const appData = response.data
      this.$store.commit(
        'setRecursiveState',
        {key: "sources.peertube.appCredentials", suffix: this.domain, value: appData}
      )
      await connect({
        domain: this.domain,
        router: this.$router,
        store: this.$store,
        username: this.username,
        password: this.password
      })
    }
  }
}
</script>
